import React from 'react';
import { Box, Typography } from '@mui/material';
import { Package } from 'lucide-react';
import Layout from '../components/Layout';
import CacheCard from '../components/CacheCard';
import MaintenanceModeCard from '../components/MaintenanceModeCard';
import ReleaseNotes from '../components/ReleaseNotes';
import { useClient } from '../ClientContext';

const styles = {
  container: {
    padding: '48px',
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    marginBottom: '32px',
  },
  title: {
    fontSize: '24px',
    fontWeight: 700,
  },
};

const CacheAndMaintenancePage = ({ user, accessToken }) => {
  const { selectedClient, config } = useClient();
  const showOperationalControls = config?.clients?.[selectedClient]?.showOperationalControls === true;

  return (
    <Layout profilePic={user.picture}>
      <Box sx={styles.container}>
        <Box sx={styles.header}>
          <Package size={24} />
          <Typography sx={styles.title}>Cache and Maintenance</Typography>
        </Box>
        {showOperationalControls && <CacheCard accessToken={accessToken} />}
        {showOperationalControls && <MaintenanceModeCard accessToken={accessToken} />}
        <ReleaseNotes accessToken={accessToken} />
      </Box>
    </Layout>
  );
};

export default CacheAndMaintenancePage;
